import {
  declareString,
  declareStringWithPlaceholders,
} from "@1js/localization";
export const CreatedByYou = declareString(
  "promptLibrary.promptCardFooter.CreatedByYou",
  {
    text: "You created this",
    comment:
      "Message displayed at the bottom of a Copilot prompt card to indicate that the user is the author of the prompt.",
  }
);

export const SuggestedByMicrosoft = declareString(
  "promptLibrary.promptCardFooter.SuggestedByMicrosoft",
  {
    text: "Microsoft suggested this",
    comment:
      "Message displayed at the bottom of a Copilot prompt card to indicate that Microsoft is the author of the prompt.",
  }
);

export const SuggestedByTenant = declareStringWithPlaceholders(
  "promptLibrary.promptCardFooter.SuggestedByTenant",
  {
    text: ({ organization }) => `${organization} suggested this`,
    comment:
      "Message displayed at the bottom of a Copilot prompt card to indicate that user's organization is the author of the prompt.",
    placeholders: {
      organization:
        "the name of the organization who shared the prompt with you",
    },
  }
);

export const SharedWithYou = declareStringWithPlaceholders(
  "promptLibrary.promptCardFooter.SharedWithYou",
  {
    text: ({ publisherName }) => `Shared by ${publisherName}`,
    comment:
      "Message displayed at the bottom of a Copilot prompt card to indicate who shared the prompt with the user. The overall message can look like this 'Shared by Robert'.",
    placeholders: {
      publisherName: "the name of the person who shared the prompt with you",
    },
  }
);
